import { Avatar, HStack, Text } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';
import { getAvatarImages } from '@vimeo/user-card';

import { Uploader } from '../../types';

export type TeamUploadedByTypes = {
  uploader: Uploader;
};

export function TeamUploadedBy({ uploader }: TeamUploadedByTypes) {
  const [avaSrc, avaSrcSet] = getAvatarImages(uploader.pictures?.sizes);

  return (
    <HStack align="center" borderTop={'1px solid'} borderColor="stroke" pt={200} spacing={8}>
      <Text as="span" variant="body-md" color="text-secondary">
        {translate('Uploaded by')}
      </Text>
      <a href={uploader.link} aria-label="Link to user profile">
        <Avatar
          src={avaSrc}
          srcSet={avaSrcSet}
          size="xs"
          alt={uploader.name}
          nameProps={{ name: uploader.name }}
        />
      </a>
      <Text as="a" href={uploader.link} variant="body-md" color="text-primary" fontWeight="bold">
        {uploader.name}
      </Text>
    </HStack>
  );
}
